<!--
 * @Author: Gaho
 * @Date: 2023-12-19 09:57:17
 * @LastEditors: Gaho
 * @LastEditTime: 2025-01-10 10:46:22
-->
<template>
    <main v-if="jackpotPercentData?.length">
        <section v-for="(item, index) in jackpotPercentData" :key="index">
            <div class="bet-percent">{{ item?.ratio * 100 + '%' }}</div>
            <div class="bet-label">{{ $t('Bet') }} ≥</div>
            <div class="bet-sum">
                <p>
                    <span>{{ currentCurrency === 'btc' ? handleExchangeRate(item.value) : getFixed(handleExchangeRate(item.value), 6) }}</span>
                </p>
                <span>{{ currentCurrency.toLocaleUpperCase() }}</span>
            </div>
        </section>
    </main>
</template>

<script lang="ts" setup>
import useSettingsStore from '@/stores/settings';
const props = defineProps({
    jackpotPercentData: {
        type: Object,
        default: {},
    },
});
const currentCurrency = computed(() => {
    return useSettingsStore().pickedCurrency || 'btc';
});

</script>

<style lang="scss" scoped>
main {
    display: flex;
    justify-content: space-between;
    section {
        flex: 1;
        border: 2px solid #2a3546;
        border-radius: 14px;
        // margin-right: 15px;
        max-width: calc(33.33333% - 10px);
        padding: 15px 10px;
        text-align: center;
        @media (max-width: 576px) {
            max-width: 33%;
            margin-right: 4px;
            &:last-child {
                margin-right: 0;
            }
        }

        .bet-percent {
            align-items: center;
            background: #ffb636;
            border: 7px solid #262e37;
            border-radius: 50%;
            color: #1c2532;
            display: flex;
            font-size: 22px;
            font-weight: 700;
            height: 72px;
            justify-content: center;
            line-height: 32px;
            margin: 0 auto 10px;
            width: 72px;
            @media (max-width: 576px) {
                border: 4px solid #262e37;
                font-size: 18px;
                height: 62px;
                width: 62px;
            }
        }

        .bet-label {
            color: #55657e;
            font-size: 14px;
            font-weight: 600;
            line-height: 18px;
            margin-bottom: 2px;
        }

        .bet-sum {
            display: flex;
            flex-wrap: nowrap;
            @media (max-width: 576px) {
                flex-direction: column;
                font-size: 12px;
            }
            span {
                font-weight: 600;
                letter-spacing: -0.5px;
                white-space: nowrap;
                &:nth-of-type(1) {
                    color: #fff;
                }
                &:nth-of-type(2) {
                    color: #55657e;
                    margin-right: 6px;
                }
                &:nth-of-type(3) {
                    color: #55657e;
                    font-size: 14px;
                    font-weight: 600;
                    line-height: 20px;
                    margin-left: 5px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
            }
        }
    }
}
</style>
